import { CategoryEntityType } from "@/types/category";
import { CreateCategoryDto } from "@/services/interfaces/ICategoryService";

/**
 * A new FAQ category goes out starred unless the caller set the star: guests see only starred
 * FAQ categories (DV-57). Canned response categories go out as they are.
 */
export const newCategoryPayload = (
  data: CreateCategoryDto,
): CreateCategoryDto =>
  data.entityType === CategoryEntityType.FAQ
    ? { ...data, isPriority: data.isPriority ?? true }
    : data;
